import adminStats from "./adminStats.json";
import billingData from "./billingData.json";
import bots from "./bots.json";
import charges from "./charges.json";
import exchangeAccounts from "./exchangeAccounts.json";
import layout from "./layout.json";
import legal from "./legal.json";
import manualPayments from "./manualPayments.json";
import market from "./market.json";
import modals from "./modals.json";
import news from "./news.json";
import paymentMethods from "./paymentMethods.json";
import payouts from "./payouts.json";
import quiz from "./quiz.json";
import referral from "./referral.json";
import referrer from "./referrer.json";
import stats from "./stats.json";
import taxProfile from "./taxProfile.json";
import users from "./users.json";
import utils from "./utils.json";

const resources = {
  adminStats,
  billingData,
  bots,
  charges,
  exchangeAccounts,
  layout,
  paymentMethods,
  stats,
  news,
  market,
  modals,
  referrer,
  payouts,
  referral,
  utils,
  quiz,
  users,
  legal,
  manualPayments,
  taxProfile,
};

export default resources;
